import { supabase } from '../lib/supabase'
import type { Field, Plant, Section, PlantWithSections } from '../lib/types'
import type { PermissionService } from './permissions'

const validId = (id: number) => Number.isInteger(id) && id > 0

export async function listPlants(): Promise<Plant[]> {
  const { data, error } = await supabase.from('plants').select('id,name,description,icon,enabled,sort_order,created_at,updated_at').eq('enabled', true).order('sort_order', { ascending: true }).order('name', { ascending: true })
  if (error) throw new Error(`Unable to load plants: ${error.message}`)
  return (data ?? []) as Plant[]
}

export async function listSections(plantId: number): Promise<Section[]> {
  if (!validId(plantId)) throw new Error('Invalid plant.')
  const { data, error } = await supabase.from('sections').select('id,plant_id,name,description,enabled,sort_order').eq('plant_id', plantId).eq('enabled', true).order('sort_order', { ascending: true }).order('name', { ascending: true })
  if (error) throw new Error(`Unable to load sections: ${error.message}`)
  return (data ?? []) as Section[]
}

export async function listFields(sectionId: number): Promise<Field[]> {
  if (!validId(sectionId)) throw new Error('Invalid section.')
  const { data, error } = await supabase.from('fields').select('id,plant_id,section_id,equipment_id,name,key,unit,data_type,source_type,formula,min_value,max_value,alarm_low,alarm_high,dashboard_default,trend_enabled,enabled,sort_order').eq('section_id', sectionId).eq('enabled', true).order('sort_order', { ascending: true }).order('name', { ascending: true })
  if (error) throw new Error(`Unable to load fields: ${error.message}`)
  return (data ?? []) as Field[]
}

export async function loadAuthorizedPlantHierarchy(permissionService: PermissionService): Promise<PlantWithSections[]> {
  const plants = await listPlants()
  const result: PlantWithSections[] = []
  for (const plant of plants) {
    const sections = await listSections(plant.id)
    const authorized = permissionService.isAdmin || permissionService.isEngineer ? sections : sections.filter(section => permissionService.can(section.id, 'can_read'))
    if (authorized.length > 0) result.push({ ...plant, sections: authorized })
  }
  return result
}
